import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getSetting, setSetting } from '../../services/api/settings';

export default function SettingsPage() {
  const { t } = useTranslation();
  const [bookingEmail, setBookingEmail] = useState('');
  const [shopifyUrl, setShopifyUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getSetting<{ booking_email?: string; merch_shopify_url?: string }>('site')
      .then((v) => {
        setBookingEmail(v?.booking_email ?? '');
        setShopifyUrl(v?.merch_shopify_url ?? '');
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  async function handleSave(e: React.FormEvent) {
    e.preventDefault();
    setSaving(true);
    try {
      const site = await getSetting<Record<string, unknown>>('site').then((v) => v ?? {});
      await setSetting('site', { ...site, booking_email: bookingEmail || undefined, merch_shopify_url: shopifyUrl || undefined });
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <p className="text-[var(--color-text-muted)]">{t('common.loading')}</p>;

  return (
    <div className="admin-page">
      <h1 className="admin-page__title">{t('admin.settingsTitle')}</h1>
      <form onSubmit={handleSave} className="admin-settings-form">
        <div className="admin-form-group">
          <label>{t('admin.bookingEmail')}</label>
          <input
            type="email"
            value={bookingEmail}
            onChange={(e) => setBookingEmail(e.target.value)}
          />
        </div>
        <div className="admin-form-group">
          <label>{t('admin.shopifyStoreUrl')}</label>
          <input
            type="url"
            value={shopifyUrl}
            onChange={(e) => setShopifyUrl(e.target.value)}
            placeholder="https://..."
          />
        </div>
        <button type="submit" disabled={saving} className="admin-btn">
          {saving ? t('admin.saving') : t('common.save')}
        </button>
      </form>
    </div>
  );
}
